module.exports = __webpack_public_path__ + "static/media/arrow.9b3705c0.svg";